import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import { useFilter } from "../../filterContext/filterContext";
import DistrictPropertyBox from './districtPropertyBox';

import districtImg1 from '../../../assets/images/district/alappuzha.jpg';
import districtImg2 from '../../../assets/images/district/kozhikkod.jpg';
import districtImg3 from '../../../assets/images/district/ernakulam.jpg';
import districtImg4 from '../../../assets/images/district/idukki.webp';
import districtImg5 from '../../../assets/images/district/kollam.jpg';
import districtImg6 from '../../../assets/images/district/Kottayam.jpg';
import districtImg7 from '../../../assets/images/district/malappuram.jpg';
import districtImg8 from '../../../assets/images/district/Palakkad.jpg';
import districtImg9 from '../../../assets/images/district/thrissur.webp';
import districtImg10 from '../../../assets/images/district/thiruvananthapuram.jpg';
import districtImg11 from '../../../assets/images/district/wayanad.jpg';

import { baseURL } from '../../axiosInterceptor/axiosInterceptorC';

function DistrictProperty() {
    const [isLoading, setIsLoading] = useState(true);
    const [districts, setDistricts] = useState([]);
    const navigate = useNavigate();
    const { saveFilterData } = useFilter();

    // Handle district click
    const handleDistrictClick = (e, districtName) => {
        e.preventDefault();
        //console.log("District clicked:", districtName);
        const filterData = {
            propertyType: [],  // Only save the selected property type as the first value in the array
            purpose: "",  // Ensure purpose is either set or empty
            selectedDistrict: districtName,  // Ensure district is either set or empty
            selectedTown: ""  // Ensure town is either set or empty
        };
        saveFilterData(filterData);
        // Optionally navigate to the properties page
        navigate("/keralaplots/properties");  // Uncomment this line to navigate
    };

    useEffect(() => {
        const fetchPropertyCounts = async () => {
            try {
                const response = await axios.get(`${baseURL}/getPropertyCounts`);
                console.log("data");
                console.log(response.data);
                if (response.data) {
                    setDistricts(response.data);  // API should return an array of district data
                }
            } catch (error) {
                console.error("Error fetching property counts:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPropertyCounts();
    }, []);

    // Mapping district names to images
    const districtImages = {
        "Alappuzha": { src: districtImg1, alt: "Alappuzha district" },
        "Calicut": { src: districtImg2, alt: "Calicut district" },
        "Ernakulam": { src: districtImg3, alt: "Ernakulam district" },
        "Idukki": { src: districtImg4, alt: "Idukki district" },
        "Kollam": { src: districtImg5, alt: "Kollam district" },
        "Kottayam": { src: districtImg6, alt: "Kottayam district" },
        "Malappuram": { src: districtImg7, alt: "Malappuram district" },
        "Palakkad": { src: districtImg8, alt: "Palakkad district" },
        "Thrissur": { src: districtImg9, alt: "Thrissur district" },
        "Thiruvananthapuram": { src: districtImg10, alt: "Thiruvananthapuram district" },
        "Wayanad": { src: districtImg11, alt: "Wayanad district" }
    };

    return (
        <section id="districtProperty">
            <div className="container">
                <h2 className="title">Kerala Properties</h2>
                <div className="districtPropertyMain">
                    {isLoading ? (
                        <div className='SkeletonLoader'>
                            <Skeleton count={6} height={100} />
                        </div>
                    ) : (
                        districts
                            .filter((district) => {
                                // Filter out districts where all property action counts are zero
                                return district.RentCount > 0 || district.SellCount > 0 || district.LeaseCount > 0;
                            })
                            .map((district) => (
                                <DistrictPropertyBox
                                    key={district.district}
                                    districtImage={districtImages[district.district]?.src || districtImg1} // Default if not found
                                    districtImageAlt={districtImages[district.district]?.alt || "District image"}  // Add alt prop
                                    districtName={district.district}
                                    districtRentItems={district.RentCount || 0}
                                    districtSellItems={district.SellCount || 0}
                                    districtLeaseItems={district.LeaseCount || 0}
                                    onClick={(e) => handleDistrictClick(e, district.district)}  // Passing the function properly
                                />
                            ))
                    )}
                </div>
            </div>
        </section>
    );
}

export default DistrictProperty;
